module.exports = __webpack_public_path__ + "static/building_red-4e6ae08a0178c8aec36fdbec92ce035f.jpg";